import { CcResponse } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"

export const setCcModuleResponseList = (moduleResponseList: types.CcModuleResponseList) => ({
    type: inferLiteral(types.CC_MODULE_RESPONSE_LIST),
    moduleResponseList,
})
export const setCcResponseList = (responseList: types.CcResponseList) => ({
    type: inferLiteral(types.CC_RESPONSE_LIST),
    responseList,
})
export const setCcResponseEdit = (response: CcResponse) => ({
    type: inferLiteral(types.CC_RESPONSE_EDIT),
    response,
})
export const setCcResponseReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_RESPONSE_RELOAD_LIST),
    value,
})
export const setCcResponseReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_RESPONSE_RELOAD_EDIT),
    value,
})
